import camelCase from '../lib/camelCase';
import Immutable from 'immutable';

function transformObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(item => transformObject(item));
    }

    if (obj.createdAt) obj.createdAt = new Date(obj.createdAt);
    if (obj.updatedAt) obj.updatedAt = new Date(obj.updatedAt);
    if (obj.deletedAt) obj.deletedAt = new Date(obj.deletedAt);
    if (obj.addressbook) obj.addressbook = transformObject(obj.addressbook);
    if (obj.billing) obj.billing = transformObject(obj.billing);
    if (obj.address) obj.address = transformObject(obj.address);

    return obj;
}

function transformLocationsFromApi(payload) {
    return transformObject(camelCase(payload));
}

export function get(api) {
    return api.get(api.url('certificate'), {
        transformResponse(json) {
            const response = JSON.parse(json);
            return response && response.payload
                ? Immutable.fromJS(transformLocationsFromApi(response.payload))
                : response;
        },
    });
}

export default {
    get,
};


